var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathGondola(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 110,
    viewBox: "0 0 84 110",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3506 14.545C55.3506 19.6533 55.3506 25.6805 55.3506 28.8882C55.3506 30.1099 55.1709 31.478 54.7325 32.8285C54.0757 34.8319 52.8973 36.7828 50.8031 38.4606H60.0813L60.2346 38.1996C61.957 35.0146 62.563 31.7287 62.5648 28.8882C62.5648 25.7693 62.5648 19.9769 62.5648 14.9645C62.5648 14.1118 62.5648 13.2973 62.5648 12.5087L69.8051 10.4636L66.7793 0L46.4951 5.72962L49.5211 16.1915L55.3506 14.545Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8808 42.5591H22.9662C15.5235 42.5591 5.84718 59.8331 5.84718 76.2803C5.84718 92.7275 15.5235 110 22.9662 110H66.8808C74.3237 110 84 92.7277 84 76.2805C84 59.8334 74.3237 42.5591 66.8808 42.5591ZM15.5498 81.286C15.312 79.65 15.1659 77.9757 15.1659 76.2805C15.1659 64.522 21.6034 53.5815 24.4812 52.3144H40.0206V81.286H15.5498ZM74.2971 81.286H48.1362V52.3144H65.3662C68.244 53.5815 74.6813 64.522 74.6813 76.2805C74.6811 77.9757 74.5351 79.65 74.2971 81.286Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6303 9.83473L0 21.3059L1.78378 27.4758L42.4141 16.0047L40.6303 9.83473Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathGondola);
export default __webpack_public_path__ + "static/media/path-gondola.8c2b255503d5f03fd5a703b64dfbfbc7.svg";
export { ForwardRef as ReactComponent };